<template>
	<div>
		<auth-container v-if="$route.name === 'SrApplicationList'" :page="page">
			<h2 class="mb-4">Applications</h2>

			<div class="mx-auto">
				<b-row class="mb-3" align-v="end">
					<b-col lg="6">
						<b-form inline>
							<b-input-group>
								<b-form-input v-model="table.filter" placeholder="Search..." @input="filterChg"></b-form-input>

								<b-input-group-append class="pointer mr-2">
									<b-input-group-text @click="clearFilter">
										<font-awesome-icon :icon="['fas', 'times']" />
									</b-input-group-text>
								</b-input-group-append>
							</b-input-group>
							<b-button variant="primary" type="button" @click="table.showAdvancedFilter = !table.showAdvancedFilter">Advanced Filter</b-button>
						</b-form>
					</b-col>
					<b-col lg="6" class="text-right">
						<div class="ml-auto">
							Showing {{showingFirst}} - {{showingLast}}
							of {{table.total}}
						</div>
					</b-col>
				</b-row>

				<b-collapse v-model="table.showAdvancedFilter" class="my-3">
					<b-card bg-variant="light">
						<b-row>
							<b-col lg="4">
								<div class="form-group row">
									<label for="advancedFilter.dam" class="col-lg-5 col-form-label">Dam NID_ID</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.dam"
													 v-model="advancedFilter.dam"
													 :data="advancedFilter.options.dam"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.fundCycle" class="col-lg-5 col-form-label">Funding Cycle</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.fundCycle"
													 v-model="advancedFilter.fundCycle"
													 :data="advancedFilter.options.fundCycle"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.sloAgent" class="col-lg-5 col-form-label">SLO</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.sloAgent"
													 v-model="advancedFilter.sloAgent"
													 :data="advancedFilter.options.sloAgent"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.requestType" class="col-lg-5 col-form-label">Request Type</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.requestType"
													 v-model="advancedFilter.requestType"
													 :data="advancedFilter.options.requestType"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>
							</b-col>
							<b-col lg>
								<div class="form-group row">
									<label for="advancedFilter.receivedDate.start" class="col-lg-3 col-form-label">Date Received Range</label>
									<div class="col-lg-9">
										<div class="d-flex align-items-center justify-content-start">
											<div class="mr-2">
												<b-input-group>
													<b-form-datepicker id="advancedFilter.receivedDate.start" v-model="advancedFilter.receivedDate.start"
																	   label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.receivedDate.start = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
											<div>
												<b-input-group>
													<b-form-datepicker id="advancedFilter.receivedDate.end" v-model="advancedFilter.receivedDate.end"
																	   label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.receivedDate.end = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
										</div>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.scoreDate.start" class="col-lg-3 col-form-label">Score Date</label>
									<div class="col-lg-9">
										<div class="d-flex align-items-center justify-content-start">
											<div class="mr-2">
												<b-input-group>
													<b-form-datepicker id="advancedFilter.scoreDate.start" v-model="advancedFilter.scoreDate.start"
																	   label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.scoreDate.start = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
											<div>
												<b-input-group>
													<b-form-datepicker id="advancedFilter.scoreDate.end" v-model="advancedFilter.scoreDate.end"
																	   label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.scoreDate.end = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
										</div>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.score.start" class="col-lg-3 col-form-label">Score Range</label>
									<div class="col-lg-9">
										<div class="d-flex align-items-center justify-content-start">
											<div>
												<b-form-input type="number" step="1" v-model="advancedFilter.score.start"></b-form-input>
											</div>
											<div class="mx-2">
												to
											</div>
											<div>
												<b-form-input type="number" step="1" v-model="advancedFilter.score.end"></b-form-input>
											</div>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
						<hr class="my-3" />
						<div>
							<b-button variant="primary" type="button" @click="get" class="mr-2">Apply</b-button>
							<b-button variant="secondary" type="button" @click="clearAdvancedFilter" class="mr-2">Clear</b-button>
							<b-button variant="secondary" type="button" @click="table.showAdvancedFilter = false">Close</b-button>
						</div>
					</b-card>
				</b-collapse>

				<b-table striped responsive table-class="table-fixed-height border-bottom table-grid" sticky-header="60vh"
						 small show-empty
						 :items="items" :busy="table.loading"
						 :fields="table.fields"
						 :no-local-sorting="true"
						 :sort-by.sync="table.sort"
						 :sort-desc.sync="table.reverse"
						 @sort-changed="sortChg">
					<template #table-busy>
						<div class="text-center my-4">
							<font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
						</div>
					</template>
					<template #cell(edit)="data">
						<router-link :to="`${data.item.id}`" append>
							<font-awesome-icon :icon="['fas', 'edit']" />
						</router-link>
					</template>
					<template #cell(damId)="data">
						<router-link :to="`/dams/${data.value}`">{{data.item.nid_id}}</router-link>
					</template>
					<template #empty>
						<h4>No records found.</h4>
					</template>
					<template #emptyfiltered>
						<h4>No records found matching "{{table.filter}}".</h4>
					</template>
				</b-table>
			</div>

			<fixed-action-bar>
				<router-link v-if="!isReadOnly" to="create" append class="btn btn-success mr-2">
					Create
				</router-link>
				<json-to-csv :api-url="`${apiUrl}/export`" :filename="apiUrl" class="mr-2" />
				<b-button v-if="isAuthorized(roleNames.superAdmin)" variant="primary" @click="page.showModal = true" class="mr-2">Import</b-button>
				<b-pagination class="ml-auto mb-0" v-if="table.total > table.itemsPerPage" size="md" :total-rows="table.total" v-model="table.currentPage" :per-page="table.itemsPerPage" @change="pageChg" />
			</fixed-action-bar>

			<b-modal v-model="page.showModal" title="Upload" scrollable size="lg">
				<error-list :errors="page.saveErrors"></error-list>
				<success-alert ref="savedAlert" text="Changes saved." />

				<vue-dropzone ref="addFile" id="addFile" :options="dropzoneOptions" @vdropzone-success="fileUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<div class="mt-3">
					<strong>IMPORTANT:</strong>
				</div>
				<ul>
					<li>Use the Download Template button to get the required columns.</li>
					<li>Column headers **must match** the template.</li>
					<li>Existing application numbers already in the database will be updated.</li>
					<li>The appNum column is required and cannot be empty.</li>
				</ul>

				<div slot="modal-footer">
					<json-to-csv :json-data="template" :filename="`${apiUrl}-template`" text="Download Template" class="mr-2" />
					<b-button type="button" variant="primary" @click="page.showModal = false" class="ml-1">Close</b-button>
				</div>
			</b-modal>
		</auth-container>
		<router-view></router-view>
	</div>
</template>

<script>
	import vue2Dropzone from 'vue2-dropzone';
	import 'vue2-dropzone/dist/vue2Dropzone.min.css';
	import _ from 'underscore';

	export default {
		name: 'SrApplicationList',
		components: {
			vueDropzone: vue2Dropzone
		},
		data() {
			return {
				apiUrl: 'srapplications',
				page: {
					errors: [],
					loading: true,
					showLogin: false,
					saveErrors: [],
					showModal: false
				},
				dropzoneOptions: {
					url: '/api/srapplications/upload/',
					headers: this.getTokenHeader().headers,
					acceptedFiles: '.csv'
				},
				table: {
					fields: [
						{ key: 'edit', label: '', stickyColumn: true },
						{ key: 'appNum', label: 'App. #', sortable: true },
						{ key: 'receivedDate', label: 'Date Received', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
						{ key: 'damId', label: 'NID_ID', sortable: true },
						{ key: 'fundCycle', label: 'Fund Cycle', sortable: true },
						{ key: 'sloAgent', label: 'SLO Agent', sortable: true },
						{ key: 'primaryName', label: 'Primary Name', sortable: true },
						{ key: 'alternateName', label: 'Alt. Name', sortable: true },
						{ key: 'requestType', label: 'Request Type', sortable: true },
						{ key: 'scoreDate', label: 'Score Date', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
						{ key: 'score', label: 'Score', sortable: true },
						{ key: 'totalEstimatedCost', label: 'Total Est. Cost', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'federalCostShare', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'stateCostShare', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'sloCostShare', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'notes', label: 'Notes', sortable: true }
					],
					sort: 'receivedDate',
					reverse: true,
					itemsPerPage: 100,
					filter: null,
					currentPage: 1,
					total: 0,
					loading: false,
					showAdvancedFilter: false
				},
				items: [],
				advancedFilter: {
					dam: null,
					fundCycle: null,
					sloAgent: null,
					requestType: null,
					receivedDate: {
						start: null,
						end: null
					},
					scoreDate: {
						start: null,
						end: null
					},
					score: {
						start: null,
						end: null
					},
					options: {
						fundCycle: [],
						sloAgent: [],
						requestType: [],
						dam: []
					}
				},
				template: [{
					appNum: null,
					receivedDate: null,
					nid_id: null,
					fundCycle: null,
					sloAgent: null,
					primaryName: null,
					alternateName: null,
					requestType: null,
					notes: null,
					scoreDate: null,
					score: null,
					federalCostShare: null,
					stateCostShare: null,
					sloCostShare: null
				}]
			}
		},
		computed: {
			showingFirst() {
				return (this.table.currentPage - 1) * this.table.itemsPerPage + 1
			},
			showingLast() {
				var max = (this.table.currentPage - 1) * this.table.itemsPerPage + this.table.itemsPerPage
				return max > this.table.total ? this.table.total : max;
			},
			advancedFilterFundCycle() {
				return this.advancedFilter.fundCycle;
			},
			advancedFiltersloAgent() {
				return this.advancedFilter.sloAgent;
			},
			advancedFilterRequestType() {
				return this.advancedFilter.requestType;
			},
			advancedFilterDam() {
				return this.advancedFilter.dam;
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get',
			advancedFilterFundCycle: _.debounce(function (query) { this.find('fundCycle', query) }, 500),
			advancedFiltersloAgent: _.debounce(function (query) { this.find('sloAgent', query) }, 500),
			advancedFilterRequestType: _.debounce(function (query) { this.find('requestType', query) }, 500),
			advancedFilterDam: _.debounce(function (query) { this.findDams('nid_id', query) }, 500)
		},
		methods: {
			getDb() {
				let sort = this.table.reverse ? this.table.sort + '_desc' : this.table.sort;
				let filter = this.table.filter !== null ? `&filter=${encodeURIComponent(this.table.filter)}` : '';

				let filterComplex = '';
				let filterValues = [];
				if (!this.isNullOrEmpty(this.advancedFilter.dam)) {
					filterValues.push(`dam:${this.advancedFilter.dam}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.fundCycle)) {
					filterValues.push(`fundCycle:${this.advancedFilter.fundCycle}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.sloAgent)) {
					filterValues.push(`sloAgent:${this.advancedFilter.sloAgent}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.requestType)) {
					filterValues.push(`requestType:${this.advancedFilter.requestType}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.receivedDate.start) || !this.isNullOrEmpty(this.advancedFilter.receivedDate.end)) {
					let s = this.advancedFilter.receivedDate.start;
					let e = this.advancedFilter.receivedDate.end;
					s = s === null ? 'any' : s;
					e = e === null ? 'any' : e;
					filterValues.push(`receivedDate:${s},${e}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.scoreDate.start) || !this.isNullOrEmpty(this.advancedFilter.scoreDate.end)) {
					let s = this.advancedFilter.scoreDate.start;
					let e = this.advancedFilter.scoreDate.end;
					s = s === null ? 'any' : s;
					e = e === null ? 'any' : e;
					filterValues.push(`scoreDate:${s},${e}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.score.start) || !this.isNullOrEmpty(this.advancedFilter.score.end)) {
					let s = this.advancedFilter.score.start;
					let e = this.advancedFilter.score.end;
					s = s === null ? 'any' : s;
					e = e === null ? 'any' : e;
					filterValues.push(`score:${s},${e}`);
				}

				if (filterValues.length > 0) filterComplex = '&filterComplex=' + filterValues.join('|');

				return this.$http.get(`${this.apiUrl}?sort=${sort}&page=${this.table.currentPage}&perPage=${this.table.itemsPerPage}${filter}${filterComplex}`, this.getTokenHeader());
			},
			async filterChg() {
				this.table.currentPage = 1;
				_.debounce(await this.get(), 500);
			},
			async pageChg(page) {
				this.table.currentPage = page;
				await this.get();
			},
			async sortChg(ctx) {
				this.table.sort = ctx.sortBy;
				this.table.reverse = ctx.sortDesc;
				this.table.specialSort = undefined;

				await this.get();
			},
			async get() {
				this.page.errors = [];
				this.table.loading = true;

				try {
					const response = await this.getDb();
					this.log(response.data);

					if (response.data.items.length == 0 && this.table.currentPage > 1) {
						this.table.currentPage--;
						await this.get();
					}

					this.items = response.data.items;
					this.table.total = response.data.total;
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				this.table.loading = false;
				this.page.loading = false;
			},
			async fileUploaded(file, response) {
				this.log(file);
				this.log(response);
				this.page.saveErrors = [];
				await this.get();
			},
			uploadError(file, message, xhr) {
				this.log(file);
				this.log(xhr);
				this.page.saveErrors.push(message);
			},
			async find(field, query) {
				try {
					const response = await this.$http.get(`/${this.apiUrl}/find/${field}/${query}`, this.getTokenHeader());
					this.advancedFilter.options[field] = response.data != '' ? response.data : [];
				} catch (error) {
					this.page.errors = this.logError(error);
				}
			},
			async findDams(field, query) {
				try {
					const response = await this.$http.get(`/dams/find/${field}/${query}`, this.getTokenHeader());
					this.advancedFilter.options.dam = response.data != '' ? response.data : [];
				} catch (error) {
					this.page.errors = this.logError(error);
				}
			},
			async clearFilter() {
				this.table.filter = null;
				await this.get();
			},
			async clearAdvancedFilter() {
				this.advancedFilter = {
					dam: null,
					fundCycle: null,
					sloAgent: null,
					requestType: null,
					receivedDate: {
						start: null,
						end: null
					},
					scoreDate: {
						start: null,
						end: null
					},
					score: {
						start: null,
						end: null
					},
					options: {
						fundCycle: [],
						sloAgent: [],
						requestType: [],
						dam: []
					}
				};

				await this.get();
			}
		}
	}
</script>